<template>
  <v-card class="elevation-0" style="width: 100%; position: absolute; bottom: 0px;">
    <v-card-text class="pa-0">
      <v-container fluid class="pa-0">
        <v-layout column fill-height>
          <v-flex grow pa-3 :style="'overflow-y: auto; height: ' + height + 'px !important;'" id="chatMessages">
            <div v-if="!messages.length" style="height: 100%;">
              <v-container fill-height>
                <v-layout row wrap align-center>
                  <v-flex xs12 sm12 md12 class="text-center">
                    <v-icon size="48" class="mb-4">far fa-comments</v-icon><br />
                    <span v-html="$t('Chat.empty')"></span>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
            <div v-else v-for="(message, m) in messages" :key="m" :class="message.userName == userName ? 'sent' : (message.firstUnread ? 'received first-unread' : 'received')">
              <div class="message mb-5">
                <div class="message-user-name" :style="'color:#'+seededRandomColor(message.userName)">{{message.userName}}</div>
                <div class="message-box mt-1">
                  <div class="pb-3">{{message.text}}</div>
                  <div><div style="float: right; font-size: 12px; opacity: 0.5">{{getTime(message.time)}}</div><div style="clear: both;"></div></div>
                </div>
              </div>
              <v-avatar class="message-user" left large><img :src="'https://avatars.dicebear.com/api/' + getSex(message.userName) + '/' + message.userName + '.svg?mood[]=happy'" /></v-avatar>
              <div style="clear: both"></div>
            </div>
          </v-flex>
          <v-flex shrink px-3 py-1 style="border-top: 1px solid #eceded">
            <v-text-field id="chatMessageText" prepend-icon="mood" append-outer-icon="send" @keydown.enter="send" @click:append-outer="send" @click:prepend="emojiMenu=true" v-model="message"></v-text-field>
            <v-menu v-model="emojiMenu" :close-on-content-click="false" activator=".v-input__prepend-outer" offset-x nudge-left="28" nudge-bottom="28">
              <v-card flat max-width="300">
                <span v-for="(emoji, e) in emojis" :key="e" v-on:click="addEmoji(emoji)" style="cursor: pointer; margin: 2px;">{{emoji}}</span>
              </v-card>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<style>
.first-unread {
  padding-top: 12px;
  border-top: 1px solid #FF5252;
}
.message-box {
  border-radius: 0px 15px 15px 15px;
  background-color: rgb(235, 247, 255);
  border: 1px solid rgba(101, 188, 255, 0.4);
  padding: 12px 12px 4px 12px;
  color: black;
}
.sent .message-box {
  border-radius: 15px 0px 15px 15px;
  background-color: rgb(101, 188, 255);
  color: white;
}
.message-user-name {
  padding-left: 6px;
}
.sent .message-user-name {
  visibility: hidden;
}
.message {
  margin-bottom: 12px;
  width: calc(100% - 50px);
  padding: 0px 10px;
  float: right;
}
.sent .message {
  float: left;
}
.message-user {
  float: left;
}
.sent .message-user {
  float: right;
}

</style>

<script>
import { EventBus } from '@/libs/eventBus.js'

export default {
  name: 'Chat',
  props: {
    id: {
      type: String,
      default: () => null
    },
    userName: {
      type: String,
      default: () => null
    },
    getMessages: {
      type: Function,
      default: () => []
    },
    sendMessage: {
      type: Function,
      default: () => []
    },
    shown: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      emojiMenu: false,
      emojis: ["😀","😬","😁","😂","😃","😄","😅","😆","😇","😉","😊","🙂","🙃","😋","😌","😍","😘","😗","😙","😚","😜","😝","😛","🤑","🤓","😎","🤗","😏","😶","😐","😑","😒","🙄","🤔","😳","😞","😟","😠","😡","😔","😕","🙁","😣","😖","😫","😩","😤","😮","😱","😨","😰","😯","😦","😧","😢","😥","😪","😓","😭","😵","😲","🤐","😷","🤒","🤕","😴","💤","💩","😈","👿","👹","👺","💀","👻","👽","🤖","😺","😸","😹","😻","😼","😽","🙀","😿","😾","🙌","👏","👋","👍","👎","👊","✊","✌","👌","✋","👐","💪","🙏","☝","👆","👇","👈","👉","🖕","🖐","🤘","🖖","✍","💅","👄","👅","👂","👃","👁","👀","👤","👥","🗣","👶","👦","👧","👨","👩","👱","👴","👵","👲","👳","👮","👷","💂","🕵","🎅","👼","👸","👰","🚶","🏃","💃","🙇","💁","🙅","🙆","🙋","🙎","🙍","💇","💆","👪","👚","👕","👖","👔","👗","👙","👘","💄","💋","👣","👠","👡","👢","👞","👟","👒","🎩","🎓","👑","⛑","🎒","👝","👛","👜","💼","👓","🕶","💍","🌂"],
      males: ["jirka","jiri","honza","jan","petr","pepa","josef","pavel","martin","jarda","jaroslav","tom","tomas","mirek","miroslav","zdenda","zdenek","franta","frantisek","vasek","vena","vaclav","michal","milan","karel","kuba","jakub","lukas","david","vladimir","lada","ladislav","ondra","ondrej","roman","standa","stanislav","mara","marek","radek","dan","daniel","tonda","antonin","vojta","vojtech","filip","adam","miloslav","mates","matej","ales","jarek","jaromir","libor","dominik","patrik","vlastimil","jindra","jindrich","milos","olda","oldrich","lubomir","ruda","rudolf","ivan","lubos","bob","robert","stepan","radim","richard","bohous","bohumil","matyas","vita","vit","ivo","rosta","rostislav","ludek","dusan","kamil","simon","vlada","vladislav","zbyna","zbynek","bohuslav","michael","alois","viktor","stefan","vitezslav","rene","jozef","jan","krystof","eduard","marcel","emil","dalibor","ludvik","radomir","tadeas","otakar","vilem","sam","samuel","bedrich","alexandr","denis","vrata","vratislav","leos","radovan","breta","bretislav","marian","premek","premysl","robin","erik", "slavomir", "slavo"],
      females: ["jana","marie","eva","hanka","hana","anicka","anna","lenka","katka","katerina","lucka","luca","lucie","vera","aja","alena","petra","verca","veronika","jarka","jaroslava","terez","tereza","martina","michaela","jitka","helca","helena","ludmila","zdenka","ivana","monca","monika","eliska","zuzka","zuzana","marketa","jarmila","bara","barbora","jirina","marcela","kristyna","dana","dagmar","adela","pavla","vlasta","miroslava","andrea","irca","irena","bozena","klara","liba","libuse","marta","sarka","nikola","karolina","iveta","pavlina","naty","natty","natalie","olina","olga","blanka","gabriela","renata","aneta","simona","ruzena","radka","daniela","denisa","iva","zdenka","milada","milena","romana","miloslava","miluse","ilona","anezka","sona","kamila","stanislava","nela","vladimira","nadezda","kvetoslava","renata","danuse","vendula","drahomira","julie","jindriska","emilie","viktorie","alzbeta","sara","stepanka","dominika","ema","sabina","magdalena","nikol","sofie","maria","frantiska","ladislava","bohumila","alice","magdalena","zaneta","linda","alexandra","silvie","laura","kristina","kveta","karla","adriana","leona","jolana","erika","terezie","edita","vaclava","amalie","blazena","antonie","lada","hedvika","magda","kvetuse","sandra","vanesa","elena","dita","emma","tatana","bohuslava","darina","vladislava","margita","radmila","johana","valerie","sylva","svatava","ivona","ester","bronislava","svetlana","rozalie","karin","ivanka","michala","bara","nina","oldriska","patricie","agata","jindra","drahoslava","josefa","vanda","vanessa","ella","andela","beata","karolina","zdena","nicol","elen","miluska","lidmila","jaromira","ingrid","zlata","natasa","tamara","mariana","dasa","klaudie","vlastimila","miriam","marika","maria","alenka","valentyna","sylvie","zofie","liliana","viera","lydie","natalie","nella","nada","yvona","nicole","barbara","katarina","emilia","bohdana","valerie","anita","lea","dorota","regina","sarlota","zora","radomira","zlatuse","tana","vilma","yveta","justyna","sofia", "misa"],
      message: '',
      messages: []
    }
  },
  async mounted() {
    try {
      await this.updateMessages();
      setInterval(async () => {
        await this.updateMessages();
      }, 10000);
    }
    catch (err) {
      console.log(err);
    }
  },
  watch: {
    async shown(val) {
      if (val) {
        //if (!this.messages.length)
        await this.updateMessages(true);
        EventBus.$emit('chatMessagesRead');
      }
    }
  },
  computed: {
    height() {
      return window.innerHeight - 64 - 72 - 40;
    }
  },
  methods: {
    rgbToHex(r, g, b) {
      let componentToHex = (c) => {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
      }
      return "" + componentToHex(r) + componentToHex(g) + componentToHex(b);
    },
    hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : {r:0,g:0,b:0};
    },
    rgbToHsl(r, g, b) {
        r /= 255, g /= 255, b /= 255;
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;

        if (max == min)
            h = s = 0;
        else
        {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }
        return [h, s, l];
    },
    hslToRgb(h, s, l) {
      var r, g, b;

      if (s == 0)
          r = g = b = l;
      else {
        let hue2rgb = (p, q, t) => {
          if (t < 0) t += 1;
          if (t > 1) t -= 1;
          if (t < 1/6) return p + (q - p) * 6 * t;
          if (t < 1/2) return q;
          if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
          return p;
        }

        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
      }

      return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
    },
    stringToSeed(str) {
        for(var i = 0, h = 1779033703 ^ str.length; i < str.length; i++)
            h = Math.imul(h ^ str.charCodeAt(i), 3432918353),
            h = h << 13 | h >>> 19;
        return function() {
            h = Math.imul(h ^ h >>> 16, 2246822507);
            h = Math.imul(h ^ h >>> 13, 3266489909);
            return (h ^= h >>> 16) >>> 0;
        }
    },
    seededRandomColor(str) {
      if (!str)
        return '000000';
      let seed = this.stringToSeed(str);
      let LCG = (s) => (Math.imul(741103597, s) >>> 0) / 2 ** 32;
      const symbols = '0123456789ABCDEF';      
      let color = '';      
      for (let i = 0; i < 6; i++) {
        color += symbols[Math.round(LCG(seed() + i) * 16)] || '0';
      }
      let rgb = this.hexToRgb("#"+color);
      let [h, s, l] = this.rgbToHsl(rgb.r, rgb.g, rgb.b)

      // Tweak lightnes and saturation to match our colo palette
      l = Math.max(0.25, Math.min(0.55, l));
      s = Math.max(0.3, Math.min(0.75, s));
      let [r,g,b] = this.hslToRgb(h, s, l);

      color = this.rgbToHex(r,g,b);
      
      return color;
    },
    getTime(timestamp) {
      let date = new Date(timestamp);
      let time = date.getHours() + ':' + (date.getMinutes() < 10 == 1 ? '0' : '') + date.getMinutes();

      let todaysDate = new Date();

      // if not the same date, show the date as well
      if (date.setHours(0,0,0,0) != todaysDate.setHours(0,0,0,0))
        return date.getDate() + ". " + (date.getMonth() + 1) + ". " + time;

      return time;
    },
    addEmoji(emoji) {
      this.message += emoji;
      this.emojiMenu = false;
    },
    async updateMessages(clearPreviousUnread) {
      if (!this.shown || document.hidden)
        return;

      let firstUnreadTimestamp = 0;

      if (this.messages && this.messages.length && !clearPreviousUnread) {
        let firstUnreadMessage = this.messages.find((message) => message.firstUnread == true);
        if (firstUnreadMessage)
          firstUnreadTimestamp = firstUnreadMessage.time;
      }

      let lastPrev = localStorage.getItem("lastMessage-" + this.id);
      let nextIsUnread = false;
      let prevCount = this.messages.length;
      this.messages = await this.getMessages();
      let latest = 0;

      if (this.messages) {
        for (let message of this.messages) {
          if (message.time > latest)
            latest = message.time;
          
          if (clearPreviousUnread && nextIsUnread && message.userName != this.name) {
            message.firstUnread = true;
            nextIsUnread = false;
          }

          if (clearPreviousUnread && (message.time == lastPrev || !lastPrev)) {
            nextIsUnread = true;
            lastPrev = message.time;
          }

          if (!clearPreviousUnread && message.time == firstUnreadTimestamp)
            message.firstUnread = true;
        }
      }
      localStorage.setItem("lastMessage-" + this.id, latest);
      // scroll only upon receiving new messages
      if (this.messages.length != prevCount) {
        this.$nextTick(() => {
          let el = document.getElementById("chatMessages");
          el.scrollTop = el.scrollHeight;
        });
      }
    },
    getSex(name) {
      let n = name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      n = n.split(' ')[0];
      if (this.males.indexOf(n) >= 0)
        return 'male';

      if (this.females.indexOf(n) >= 0)
        return 'female';

      return 'pixel-art-neutral';

      /*let seed = this.stringToSeed(name)
      let LCG = (s) => (Math.imul(741103597, s) >>> 0) / 2 ** 32;
      if (Math.round(LCG(seed()) * 2) == 0)
        return 'male';

      return 'female';*/
    },
    async send() {
      if (!this.message || !this.message.length)
        return;

      await this.sendMessage(this.message, this.userName);

      this.messages.push({
        text: this.message,
        userName: this.userName,
        time: + new Date()
      });
      this.message = '';

      this.$nextTick(() => {
        let el = document.getElementById("chatMessages");
        el.scrollTop = el.scrollHeight;
      });      
    }
  }
}
</script>